import Service from "./Service";
const baseurl = '/api/valoracion-riesgo-biopsicosocial';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByHc(params={}) {
        return Service.get(`${baseurl}/show-by-hc`,{
            params: params
        });
        //return Service.get(`${baseurl}/show-by-hc/${id_historia}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    showLast(params={}) {
        return Service.get(`${baseurl}/get-last-risk`,{
            params: params
        });
    },
    showByIdHc(id) {
        return Service.get(`${baseurl}/show-by-id-hc/${id}`);
    },
}